import React from 'react'

export default function Loader() {
  return (
    <section className="h-screen bg-gray-900 w-full flex flex-col items-center justify-center">
        <img src='https://i.gifer.com/origin/91/91accf0365e37d105841e05a21ba54db_w200.gif' alt="Loading..." />
        <br />
    </section>
  )
}
